import { AGS_REPORT_COUNTRY_DEFAULT } from '~/exportReport/exportReport.constants';
import { HighPriorityExportReportTemplates } from '~/exportReport/template/exportReportTemplates';
import { type MapSettingsDataAction } from '../../data/mapSettingsData.action';
import { type ExportReportToolStateAction } from './exportReportToolState.action';
import {
  exportReportDisable, exportReportEnable, exportReportSetSettings,
} from './exportReportToolState.actionCreators';
import { type ExportReportToolState } from './exportReportToolState.state';

export const mapSettingsExportReportInitialState: ExportReportToolState = {
  isActive: false,
  params: null,
  settings: {
    template: HighPriorityExportReportTemplates[0],
    country: AGS_REPORT_COUNTRY_DEFAULT,
    isSampleReport: false,
  },
};

export const exportReportToolStateReducer = (
  state = mapSettingsExportReportInitialState,
  action: ExportReportToolStateAction | MapSettingsDataAction
): ExportReportToolState => {
  if (exportReportEnable.match(action)) {
    return {
      ...state,
      isActive: true,
      params: action.payload.params,
    };
  }

  if (exportReportDisable.match(action)) {
    return {
      ...state,
      isActive: false,
      params: null,
    };
  }

  if (exportReportSetSettings.match(action)) {
    return {
      ...state,
      settings: action.payload.settings,
    };
  }

  return state;
};
